import React from 'react'
import { IconStar } from '@s4l/icons/IconStar'

import styles from './index.module.css'

interface IStarRating {
  /**
   * Rating value between 0 and 7
   */
  rating: number
}

export default function StarRating(props: IStarRating) {
  const { rating } = props

  if (rating < 0 || rating > 7) {
    console.error('Rating must be between 0 and 7')
    return null
  }

  const stars = Math.floor(rating)

  return (
    <div className={styles.container}>
      {Array.from({ length: stars }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <IconStar key={index} size={16} />
      ))}
    </div>
  )
}
